import { mergeDeep } from '@/helpers/utils'
import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

export default (schemas: LandingScreenSchema[]): LandingScreenSchema[] => {
	const extensionSchema: Partial<LandingScreenSchema>[] = [
		// loader-walking
		{
			components: {
				LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
					title: 'Lymphatic Walking Plan<br/>Based on Your Age',
					size: 'small',
					customStyles: {
						marginLeft: '3rem',
						marginRight: '3rem',
					},
				}),
			},
		},
		// age-walking
		{
			components: {
				LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
					title: 'Lymphatic<br/>Walking Plan',
					size: 'large',
					uppercase: true,
				}),
			},
		},
	]

	return mergeDeep([...schemas], extensionSchema)
}
